import { createFileRoute } from "@tanstack/react-router";
import { PaginaRota } from "@/paginas/ultimas-movimentacoes";

export const Route = createFileRoute("/_authenticated/ultimas-movimentacoes")({
  head: () => ({
    meta: [
      { title: "Últimas movimentações — Milky Moo Palmares" },
      {
        name: "description",
        content: "Consulte as últimas movimentações de estoque registradas.",
      },
      { property: "og:title", content: "Últimas movimentações — Milky Moo Palmares" },
      {
        property: "og:description",
        content: "Consulte as últimas movimentações de estoque registradas.",
      },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary" },
    ],
  }),
  component: PaginaRota,
});
